import { MessageBox } from '../message-box.model';
import { CustomMessageType } from './custom-message-type.enum';

export enum CustomMessage {
  //BEGIN INFORMATION MESSAGES
  InfoSelectSignatures = 'InfoSelectSignatures',
  InfoSignaturePaymentProgress = 'InfoSignaturePaymentProgress',
  InfoSignatureProgress = 'InfoSignatureProgress',
  InfoPaymentProgress = 'InfoPaymentProgress',
  InfoPaymentCollected = 'InfoPaymentCollected',
  InfoManualPaymentGettingPaymentData = 'InfoManualPaymentGettingPaymentData',
  //END INFORMATION MESSAGES

  //BEGIN SUCCESSFUL MESSAGES
  SuccessDevice = 'SuccessDevice',
  SuccessSignature = 'SuccessSignature',
  SuccessPayment = 'SuccessPayment',
  //SuccessSignaturePayment = 'SuccessSignaturePayment',
  //END SUCCESSFUL MESSAGES

  //BEGIN WARNING MESSAGES
  WarnSignaturePayment = 'WarnSignaturePayment',
  WarnCash = 'WarnCash',
  WarnConnect = 'WarnConnect',
  WarnChangeDevice = 'WarnChangeDevice',
  WarnSignature = 'WarnSignature',
  WarnSomething = 'WarnSomething',
  //END WARNING MESSAGES

  //BEGIN ERROR MESSAGES
  ErrorMoby = 'ErrorMoby',
  ErrorDeclined = 'ErrorDeclined',
  ErrorCanceled = 'ErrorCanceled',
  ErrorRedirect = 'ErrorRedirect',
  ErrorCustomTimeOutFromIPad = 'ErrorCustomTimeOutFromIPad',
  ErrorCreditAccount = 'ErrorCreditAccount',
  ErrorManualPaymentInvoiceCreation = 'ErrorManualPaymentInvoiceCreation',
  ErrorManualPaymentGetToken = 'ErrorManualPaymentGetToken',
  //END ERROR MESSAGES
}

export const mapMessage = new Map<string, MessageBox>();

//BEGIN INFORMATION MESSAGES
mapMessage.set('InfoSelectSignatures', { text: 'Signatures must be selected in order to proceed.', type: CustomMessageType.Information });
mapMessage.set('InfoSignaturePaymentProgress', { text: 'Signatures and payment in progress.', type: CustomMessageType.Information });
mapMessage.set('InfoSignatureProgress', { text: 'Signatures are in progress.', type: CustomMessageType.Information });
mapMessage.set('InfoPaymentProgress', { text: 'Payment is in progress.', type: CustomMessageType.Information });
mapMessage.set('InfoPaymentCollected', { text: 'Payment collected. No Further action required.', type: CustomMessageType.Information });
mapMessage.set('InfoManualPaymentGettingPaymentData', {
  text: 'Retrieving payment data from Citrix.',
  type: CustomMessageType.Information,
});
//END INFORMATION MESSAGES

//BEGIN SUCCESSFUL MESSAGES
mapMessage.set('SuccessDevice', { text: '', type: CustomMessageType.Success });
mapMessage.set('SuccessSignature', { text: 'Signature successfully completed.', type: CustomMessageType.Success });
mapMessage.set('SuccessPayment', { text: 'Payment successfully completed.', type: CustomMessageType.Success });
//mapMessage.set('SuccessSignaturePayment', { text: 'Signatures and payment successfully completed.', type: CustomMessageType.Success });
//END SUCCESSFUL MESSAGES

//BEGIN WARNING MESSAGES
mapMessage.set('WarnSignaturePayment', { text: 'Signatures and payment are not required.', type: CustomMessageType.Warning });
mapMessage.set('WarnCash', {
  text: 'Please acknowledge that you have received the total amount in cash.',
  type: CustomMessageType.Warning,
});
mapMessage.set('WarnConnect', { text: 'In order to proceed, please connect to an iPad device.', type: CustomMessageType.Warning });
mapMessage.set('WarnChangeDevice', { text: 'The iPad device cannot be changed during the transaction.', type: CustomMessageType.Warning });
mapMessage.set('WarnSignature', { text: 'Signatures are not required. Please proceed with the payment.', type: CustomMessageType.Warning });
mapMessage.set('WarnSomething', {
  text: 'Something happened. Please exit to iCargo to reinitiate the transaction or contact support for assistance.',
  type: CustomMessageType.Warning,
});

//END WARNING MESSAGES

//BEGIN ERROR MESSAGES
mapMessage.set('ErrorManualPaymentInvoiceCreation', {
  text: 'Something happened while passing data to Citrix. Please exit to iCargo and try again or contact support.',
  type: CustomMessageType.Error,
});
mapMessage.set('ErrorMoby', {
  text: 'Error: Card reader is inactive. Please contact IT support.',
  type: CustomMessageType.Error,
});
mapMessage.set('ErrorDeclined', {
  text: 'Transaction declined. Please exit to iCargo to try another form of payment.',
  type: CustomMessageType.Error,
});
mapMessage.set('ErrorCanceled', {
  text: 'The current transaction has been canceled by the customer. Please exit back to iCargo to re-initiate transaction.',
  type: CustomMessageType.Error,
});
mapMessage.set('ErrorSomething', {
  text: 'Something happened. Please exit to iCargo to reinitiate the transaction.',
  type: CustomMessageType.Error,
});
mapMessage.set('ErrorRedirect', {
  text: 'Error: Manual authorization required. Before closing your browser, please record this authorization code for manager override: ',
  type: CustomMessageType.Error,
});
mapMessage.set('ErrorRedirect', {
  text: 'Error: Manual authorization required. Before closing your browser, please record this authorization code for manager override: ',
  type: CustomMessageType.Error,
});
mapMessage.set('ErrorCustomTimeOutFromIPad', {
  text: 'An error occurred. Please try again to complete the transaction.',
  type: CustomMessageType.Error,
});
mapMessage.set('ErrorCreditAccount', {
  text: 'Contact Credit Department 206-392-7989 (Mon to Fri 7:00 AM - 3:00 PM) or Email to <a href="mailto:Credit.Collections@alaskaair.com">Credit.Collections@alaskaair.com</a>',
  type: CustomMessageType.Error,
});
mapMessage.set('ErrorManualPaymentGetToken', {
  text: 'Unable to retrieve data from Citrix. Please exit back to iCargo and retry the transaction.',
  type: CustomMessageType.Error,
});
//END ERROR MESSAGES
